import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

const useGeneralList = (resource) => {
  const [datas, setDatas] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getDatas() {
      try {
        const datas = await dataProvider.getList(resource, {});
        setDatas(datas.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getDatas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { datas, loading, error };
};

export default useGeneralList;
